import { gql } from '@apollo/client';

const SEND_CIED_COMING_SOON_REQUEST_MUTATION = gql`
  mutation sendCIEDComingSoonRequest($input: SendCIEDComingSoonRequestInput!) {
    sendCIEDComingSoonRequest(input: $input) {
      isSuccess
      message
    }
  }
`;

export default SEND_CIED_COMING_SOON_REQUEST_MUTATION;
